<template>
	<progress :style="{opacity: (loading) ? 1 : 0}"></progress>
</template>

<script>
	export default {
		props: ['loading']
	}
</script>